import { render } from "./StoreTabDevices.vue?vue&type=template&id=79b2df62&scoped=true&ts=true"
import script from "./StoreTabDevices.vue?vue&type=script&lang=ts"
export * from "./StoreTabDevices.vue?vue&type=script&lang=ts"

import "./StoreTabDevices.vue?vue&type=style&index=0&id=79b2df62&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b2df62"]])

export default __exports__